/**
 * Created by hernanherreros on 2019-05-28
 */

import * as React from 'react'
import styled, { css } from 'styled-components'
import Timer from 'react-compound-timer'
import { Icon, Modal } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import { flowRight } from 'lodash'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import { TIMER_MINUTES } from '../../config/index.config'

interface Props extends RouteComponentProps<any>, ComponentProps {
  timer: any;
  color: string;
  minutes?: number;
  changeExpiredState?: any;
}

interface State {
}

class Countdown extends React.Component<Props, State> {
  timer = React.createRef()

  componentWillMount () {
    const { timer, minutes } = this.props

    if (minutes !== undefined) {
      timer.setTime(minutes)
    } else {
      const startTime = localStorage.getItem('timer_' + this.getTokenParam())

      if (!startTime) {
        this.resetTime()
      } else {
        const date = new Date(startTime)
        const now = new Date()
        const diff = TIMER_MINUTES - (now.getTime() - date.getTime())
        timer.setTime(diff > 0 ? diff : 0)
      }
    }
  }

  componentDidUpdate (prevProps: Props, prevState: State) {
    const { timer, minutes,changeExpiredState } = this.props
    const time = timer.getTime()

    if (time <= 0 && minutes !== undefined) {
      changeExpiredState()
    }

    if (time >= 0 && time < 1000 && minutes === undefined) {
      this.showTimeOutModal()
    }

  }

  resetTime = () => {
    const { timer } = this.props
    const date = new Date().toISOString()

    localStorage.setItem('timer_' + this.getTokenParam(), date)

    timer.reset()
    timer.start()
  }

  getTokenParam = () => {
    const { match } = this.props
    return match.params.token
  }

  showTimeOutModal = () => {
    const { history, congress } = this.props

    Modal.confirm({
      title: <Trans>El tiempo se ha terminado.</Trans>,
      content: <Trans>¿Desea 15 minutos más para seguir con su inscripción?</Trans>,
      onOk: this.resetTime,
      onCancel: () => {
        history.push('/' + congress.Slug)
      }
    })
  }

  render () {
    const { color, minutes } = this.props

    return (
      <div>
        <Container color={color}>
          <Clock color={color}>
            <Icon type="clock-circle" theme="filled"/>
          </Clock>

          <Wrapper>

            {minutes === undefined ? null : <React.Fragment>
              <Number color={color}>
                <Timer.Days />
                <Label><Trans>Días</Trans></Label>
              </Number>

              <Separator color={color}>:</Separator>
              <Number color={color}>
                <Timer.Hours />
                <Label><Trans>Horas</Trans></Label>
              </Number>

              <Separator color={color}>:</Separator>
            </React.Fragment>}

            <Number color={color}>
              <Timer.Minutes/>
              {minutes === undefined ? null : <Label><Trans>Min</Trans></Label>}
            </Number>

            <Separator color={color}>:</Separator>

            <Number color={color}>
              <Timer.Seconds/>
              {minutes === undefined ? null : <Label><Trans>Seg</Trans></Label>}
            </Number>
          </Wrapper>
        </Container>

        {minutes !== undefined ? null : <Note color={color}><Trans>Cupo reservado por 15 minutos</Trans></Note>}
      </div>
    )
  }
}

const Container = styled.div`
  height: 50px;
  padding: 10px 0;
 
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media screen and (max-width: 40em) {
    border: none;
  }
  
  ${({ color }) => css`border-right: 3px solid ${color};`}
`

const Wrapper = styled.div`
  display: flex;
`

const Clock = styled.div`
  font-size: 30px;
  margin-right: 5px;

  ${({ color }) => css`color: ${color};`}
`

const Number = styled.div`
  font-size: 35px;
  font-weight: 400;
  padding-bottom: 11px;
  flex-direction: column;
  display: flex;
  position: relative;
  
  ${({ color }) => css`color: ${color};`}
`

const Label = styled.span`
  position: absolute;
  font-size: 15px;
  left: 0;
  bottom: 0;
  margin-top: 10px;
  width: 100%;
  text-align: center;
`

const Separator = styled.div`
  font-size: 35px;
  font-weight: 400;
  
  ${({ color }) => css`color: ${color};`}
`

const Note = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 12px;

  ${({ color }) => css`color: ${color};`}
`

const withTimer = (WrappedComponent: React.ComponentClass<any>) => (wrappedComponentProps: Props) => (
  <Timer initialTime={TIMER_MINUTES} direction="backward"
         formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`}>
    {(timerRenderProps: any) =>
      <WrappedComponent {...wrappedComponentProps} timer={timerRenderProps}/>}
  </Timer>
);

export default flowRight([withRouter, withTimer, withCongress])(Countdown)